// src/components/Layout.jsx
import SideBar from './sideBar/SideBar'
import { Header } from './header/Header'
import { SidebarProvider } from './sideBar/SidebarContext'
import AssistantPet from '../modules/ui/AssistantPet'
import { TryLucaChatProvider } from '../modules/views/contableAgent/context/TryLucaChatContext'
import SupportSessionBanner from './SupportSessionBanner'

const Layout = ({ children, className = '' }) => {
  return (
    <SidebarProvider>
      <TryLucaChatProvider>
        {/* La altura sigue el area visible, tambien en navegadores moviles. */}
        <div className="flex overflow-hidden bg-slate-100/70" style={{ height: 'var(--app-viewport-height)' }}>
          <SideBar />
          <AssistantPet />

          {/* Contenedor principal: flex-col para header + main */}
          <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-y-auto overscroll-y-contain">
            <SupportSessionBanner />
            <Header />

            {/* 
              flex-1: ocupa todo el alto restante
              w-full: ocupa siempre todo el ancho disponible
            */}
            <main
              className={`app-main flex-1 min-w-0 w-full overflow-x-auto px-2 sm:px-4 py-3 hd:py-5 ${className}`}
            >
              {children}
            </main>
          </div>
        </div>
      </TryLucaChatProvider>
    </SidebarProvider>
  )
}

export default Layout
